// import React, { useState, useEffect } from "react";

// import UserService from "../services/user.service";
// import EventBus from "../common/EventBus";

// const BoardAdmin = () => {
//   const [content, setContent] = useState("");

//   useEffect(() => {
//     UserService.getAdminBoard().then(
//       (response) => {
//         setContent(response.data);
//       },
//       (error) => {
//         const _content =
//           (error.response &&
//             error.response.data &&
//             error.response.data.message) ||
//           error.message ||
//           error.toString();

//         setContent(_content);

//         if (error.response && error.response.status === 401) {
//           EventBus.dispatch("logout");
//         }
//       }
//     );
//   }, []);

//   return (
//     <div className="container">
//       <header className="jumbotron">
//         <h3>{content}</h3>
//       </header>
//     </div>
//   );
// };

// export default BoardAdmin;
import React, { useState } from "react";
import { Layout, Menu, Table, Tabs, Card, Descriptions } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  BookOutlined,
  CommentOutlined,
  TagsOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";

const { Header, Content, Footer, Sider } = Layout;
const { TabPane } = Tabs;

// Exemple de données pour chaque section
const instructorsData = [
  {
    key: "1",
    name: "soufiane amestak",
    email: "soufiane.amestak.pro@gmail.com",
    phone: "+14188096316",
    text: "devenir professeur sur votre plateforme",
    status: "Approved",
  },
  {
    key: "2",
    name: "malaoui taoufik",
    email: "malaouitaoufik1@gmail.com",
    phone: "0662455031",
    text: "123",
    status: "Approved",
  },
];

const coursesData = [
  {
    key: "1",
    title: "Angular Basics",
    price: "$30",
    category: "IT & Software",
    status: "Published",
  },
  {
    key: "2",
    title: "React Advanced",
    price: "$50",
    category: "Development",
    status: "Draft",
  },
];

// Colonnes pour le tableau des instructeurs
const instructorsColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Text",
    dataIndex: "text",
    key: "text",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span style={{ color: status === "Approved" ? "green" : "red" }}>
        {status}
      </span>
    ),
  },
];

// Colonnes pour le tableau des cours
const coursesColumns = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span style={{ color: status === "Published" ? "green" : "red" }}>
        {status}
      </span>
    ),
  },
];

const BoardAdmin = () => {
  const [selectedMenu, setSelectedMenu] = useState("dashboard");

  const renderContent = () => {
    switch (selectedMenu) {
      case "dashboard":
        return (
          <div>
            <h2>Admin Dashboard</h2>
            <Card>
              <Descriptions title="Statistiques Globales" bordered>
                <Descriptions.Item label="Total Students">5</Descriptions.Item>
                <Descriptions.Item label="Total Courses">11</Descriptions.Item>
                <Descriptions.Item label="Total Instructors">3</Descriptions.Item>
                <Descriptions.Item label="Total Sales">$149.96</Descriptions.Item>
              </Descriptions>
            </Card>
          </div>
        );
      case "courses":
        return (
          <div>
            <h2>Courses</h2>
            <Table columns={coursesColumns} dataSource={coursesData} />
          </div>
        );
      case "instructors":
        return (
          <div>
            <h2>Instructors</h2>
            <Table columns={instructorsColumns} dataSource={instructorsData} />
          </div>
        );
      case "students":
        return <h2>Students - Coming Soon</h2>;
      case "partners":
        return <h2>Partners - Coming Soon</h2>;
      case "testimonials":
        return <h2>Testimonials - Coming Soon</h2>;
      case "categories":
        return <h2>Categories - Coming Soon</h2>;
      case "coupons":
        return <h2>Coupons - Coming Soon</h2>;
      default:
        return <h2>Welcome to Admin Dashboard</h2>;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider>
        {/* <div className="logo" style={{ height: "64px", margin: "16px" }}>
          <img src="/img/nomidya.png" alt="Nomidya" style={{ height: "40px" }} />
        </div> */}
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["dashboard"]}
          onClick={(e) => setSelectedMenu(e.key)}
        >
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            Dashboard
          </Menu.Item>
          <Menu.Item key="courses" icon={<BookOutlined />}>
            Courses
          </Menu.Item>
          <Menu.Item key="instructors" icon={<TeamOutlined />}>
            Instructors
          </Menu.Item>
          <Menu.Item key="students" icon={<UserOutlined />}>
            Students
          </Menu.Item>
          <Menu.Item key="partners" icon={<AppstoreAddOutlined />}>
            Partners
          </Menu.Item>
          <Menu.Item key="testimonials" icon={<CommentOutlined />}>
            Testimonials
          </Menu.Item>
          <Menu.Item key="categories" icon={<TagsOutlined />}>
            Categories
          </Menu.Item>
          <Menu.Item key="coupons" icon={<BookOutlined />}>
            Coupons
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Header style={{ padding: "0", backgroundColor: "#F0F9FA" }}>
          {/* <h2 style={{ padding: "16px" }}>Admin Dashboard</h2> */}
        </Header>
        <Content style={{ margin: "16px" }}>{renderContent()}</Content>
        <Footer style={{ textAlign: "center" }}>
          ©2024 Nomidya. Tous droits réservés.
        </Footer>
      </Layout>
    </Layout>
  );
};

export default BoardAdmin;
